// extracted by mini-css-extract-plugin
var _1 = "kxv3s";
var _2 = "rmSEI";
var _3 = "xf38u";
var _4 = "ZgWAL";
export { _1 as "base", _2 as "description", _3 as "leftPane", _4 as "rightPane" }
